class IngredientsVsor {
  constructor(container) {
    this.container = container;
    this.swiperInstance = null;
    this.init();
  }

  init() {
    this.setupSwiper();
    this.bindEvents();
  }

  setupSwiper() {
    if (typeof Swiper === 'undefined') {
      return;
    }

    const swiperElement = this.container.querySelector('.ingredients-vsor__swiper');
    if (!swiperElement) return;

    this.swiperInstance = new Swiper(swiperElement, {
      slidesPerView: 1.2,
      spaceBetween: 12,
      centeredSlides: false,
      slidesPerGroup: 1,
      pagination: {
        el: '.ingredients-vsor__pagination',
        clickable: true,
        bulletClass: 'swiper-pagination-bullet',
        bulletActiveClass: 'swiper-pagination-bullet-active'
      },
      breakpoints: {
        991: {
          slidesPerView: 4,
          spaceBetween: 12
        }
      }
    });
  }

  bindEvents() {
  }

  destroy() {
    if (this.swiperInstance) {
      this.swiperInstance.destroy(true, true);
      this.swiperInstance = null;
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('[data-section-type="ingredients-vsor"]');
  sections.forEach(section => {
    new IngredientsVsor(section);
  });
});

if (Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.querySelector('[data-section-type="ingredients-vsor"]')) {
      const section = event.target.querySelector('[data-section-type="ingredients-vsor"]');
      new IngredientsVsor(section);
    }
  });

  document.addEventListener('shopify:section:unload', (event) => {
    if (event.target.querySelector('[data-section-type="ingredients-vsor"]')) {
      const section = event.target.querySelector('[data-section-type="ingredients-vsor"]');
      if (section.ingredientsVsorInstance) {
        section.ingredientsVsorInstance.destroy();
      }
    }
  });
}
